<template lang="pug">
    .ma-sm-2()

        v-snackbar(
            v-model='snackbar.show'
            :color='snackbar.color'
            :timeout="snackbar.timeout"
            top
        )
            | {{ snackbar.text }}
            v-btn(dark text @click='snackbar.show = false')
                | Close

        .text-center(v-if="isLoading")
            v-progress-circular(
                :size='100'
                :width='10'
                color='var(--volie-blue)'
                indeterminate
                style="margin-top: 100px;"
            )

        v-container.mx-auto(v-if="!isLoading")
            VinSolutionsActivityDetails(
                v-if="validVinSolutionsDetails"
                v-for='detail in vinSolutionsDetails'
                :key='detail.vid'
                :vin-solutions-activity="detail"
                :activity-type="findActivityType(detail)"
            )

            v-alert(outlined type='warning' dense border='left' style="margin-top: 16px;" v-if="!validVinSolutionsDetails && !vinSolutionsError.length > 0")
                | Customer does not have any vin solutions activities

            v-alert(outlined type='warning' dense border='left' style="margin-top: 16px;" v-if="!isLoading && vinSolutionsError.length > 0")
                | {{ vinSolutionsError || "There was a problem retrieving activities." }}

</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import VinSolutionsActivityDetails from '@/components/vin_solutions/details.vue';
    
    // Data
    import { GetCommandList } from "@/data";

    export default Vue.extend({
        data() {
            return {
                vinSolutionsError: "",
                vinSolutionsDetails: [],
                isLoading: false,
                snackbar: {
                    show: false,
                    timeout: 2500,
                },
            }
        },
        methods: {
            findActivityType(detail) {
                if (!(detail?.command_name?.length > 0)) {
                    return "default";
                } 
                
                // Add more cases as needed
                switch (detail.command_name.toLowerCase()) {
                    case "customer_update":
                        return "Customer";
                    case "create_call_log":
                        return "Call";
                    default:
                        return "default";
                }
            },
            getVinSolutionsCustomerCommandHistory() {
                if (!this.validCurrentCampaignCustomer || !this.validCampaignCustomerCustomerId) {
                    return;
                }

                const options = {
                    organization_id: this.currentCampaignCustomer.organization_id,
                    campaign_customer_id: this.currentCampaignCustomer.campaign_customer_id,
                    // command_name: searchObj.commandName, // TODO:
                };

                this.vinSolutionsError = ""; // reset error message
                this.isLoading = true;
                GetCommandList(options).then((response) => {
                    if (response?.Data?.customer_command_history?.length > 0) {
                        this.vinSolutionsDetails = response.Data.customer_command_history;
                    } else {
                        if (response?.Error?.length > 0) {
                            this.vinSolutionsError = "Unable to get activities: " + response.Error;
                        }
                    }

                    this.isLoading = false;
                });
            },
            showSnackbar(color, text) {
                if (color?.length > 0 && text?.length > 0) {
                    this.snackbar.color = color;
                    this.snackbar.text = text;
                    this.snackbar.show = true;
                }
            },
        },
        computed: {
            validCurrentCampaignCustomer() {
                return this.currentCampaignCustomer?.customer_id > 0
            },
            validCampaignCustomerCustomerId() {
                return this.currentCampaignCustomer?.customer_id > 0;
            },
            validVinSolutionsDetails() {
                return this.vinSolutionsDetails?.length > 0;
            },
        },
        components: {
            VinSolutionsActivityDetails,
        },
        watch: {
        },
        props: {
            currentCampaignCustomer: Object,
        },
        created() {
            this.getVinSolutionsCustomerCommandHistory();
        },
        destroyed() {
        }
    });
</script>

<style lang="scss" scoped>
</style>
